module.exports = __webpack_public_path__ + "img/baobiao.36b02f60.png";